var _path, _circle, _line, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.9286L3.28211 11.7115L3.21644 11.9287L3.28214 12.1458L4 11.9286ZM20 11.9278L20.7179 12.1449L20.7835 11.9278L20.7178 11.7106L20 11.9278ZM4.71789 12.1457C5.67768 8.97224 8.58148 6.67822 12.0001 6.67822V5.17822C7.8887 5.17822 4.424 7.93592 3.28211 11.7115L4.71789 12.1457ZM12.0001 6.67822C15.4185 6.67822 18.3221 8.97189 19.2821 12.145L20.7178 11.7106C19.5757 7.9355 16.1112 5.17822 12.0001 5.17822V6.67822ZM19.2821 11.7107C18.3223 14.8842 15.4185 17.1782 11.9999 17.1782V18.6782C16.1113 18.6782 19.576 15.9205 20.7179 12.1449L19.2821 11.7107ZM11.9999 17.1782C8.5815 17.1782 5.67788 14.8845 4.71786 11.7114L3.28214 12.1458C4.42429 15.9209 7.88878 18.6782 11.9999 18.6782V17.1782Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.2222,
    y1: 6.50561,
    x2: 6.8384,
    y2: 17.8894,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 4.81714L4.62855 17.89",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeClose);
export default __webpack_public_path__ + "static/media/icon-eye-close.51d313ed7b179cb40fc8b1787f470b92.svg";
export { ForwardRef as ReactComponent };